export const BookingStatus = [
    { name: 'APPROVED', code: 'APPROVED' },
    { name: 'PENDING', code: 'PENDING' },
    { name: 'TO BE CANCEL', code: 'TO BE CANCEL' },
    { name: 'CANCELLED', code: 'CANCELLED' },
]